module.exports = __webpack_public_path__ + "img/Avatar-14.cc1df336.gif";